/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CountryListResponse } from '../models/CountryListResponse';
import type { DataPermissionListResponse } from '../models/DataPermissionListResponse';
import type { GrantCountryAccessRequest } from '../models/GrantCountryAccessRequest';
import type { GrantDataPermissionRequest } from '../models/GrantDataPermissionRequest';
import type { GrantValueChainAccessRequest } from '../models/GrantValueChainAccessRequest';
import type { PermissionGrantResponse } from '../models/PermissionGrantResponse';
import type { PermissionsOverviewResponse } from '../models/PermissionsOverviewResponse';
import type { PermissionSummaryResponse } from '../models/PermissionSummaryResponse';
import type { UserPermissionsResponse } from '../models/UserPermissionsResponse';
import type { ValueChainListResponse } from '../models/ValueChainListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PermissionsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get User Permissions
     * Get all permissions for the current user.
     *
     * Args:
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * UserPermissionsDetailResponse: Complete user permissions
     * @returns UserPermissionsResponse Successful Response
     * @throws ApiError
     */
    public getUserPermissionsApiV1AuthPermissionsGet(): CancelablePromise<UserPermissionsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/permissions',
        });
    }
    /**
     * Get User Permissions
     * Get all permissions for the current user.
     *
     * Args:
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * UserPermissionsDetailResponse: Complete user permissions
     * @returns UserPermissionsResponse Successful Response
     * @throws ApiError
     */
    public getUserPermissionsApiV1AuthPermissionsGet1(): CancelablePromise<UserPermissionsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/permissions',
        });
    }
    /**
     * Get Permissions Overview
     * Aggregated overview for UI:
     * - value_chains_count: max of active value chain grants and active graph_source data permissions
     * - company_mapping_countries: active data permissions with data_type='country' (names/identifiers)
     * - financial_data_access: list of {country, source} from UserFinancialDataAccess
     * @returns PermissionsOverviewResponse Successful Response
     * @throws ApiError
     */
    public getPermissionsOverviewApiV1AuthPermissionsOverviewGet(): CancelablePromise<PermissionsOverviewResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/permissions/overview',
        });
    }
    /**
     * Get Permissions Overview
     * Aggregated overview for UI:
     * - value_chains_count: max of active value chain grants and active graph_source data permissions
     * - company_mapping_countries: active data permissions with data_type='country' (names/identifiers)
     * - financial_data_access: list of {country, source} from UserFinancialDataAccess
     * @returns PermissionsOverviewResponse Successful Response
     * @throws ApiError
     */
    public getPermissionsOverviewApiV1AuthPermissionsOverviewGet1(): CancelablePromise<PermissionsOverviewResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/permissions/overview',
        });
    }
    /**
     * Get Permissions Summary
     * Get a summary of user permissions.
     *
     * Args:
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionSummaryResponse: Permission summary statistics
     * @returns PermissionSummaryResponse Successful Response
     * @throws ApiError
     */
    public getPermissionsSummaryApiV1AuthPermissionsSummaryGet(): CancelablePromise<PermissionSummaryResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/permissions/summary',
        });
    }
    /**
     * Get Permissions Summary
     * Get a summary of user permissions.
     *
     * Args:
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionSummaryResponse: Permission summary statistics
     * @returns PermissionSummaryResponse Successful Response
     * @throws ApiError
     */
    public getPermissionsSummaryApiV1AuthPermissionsSummaryGet1(): CancelablePromise<PermissionSummaryResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/permissions/summary',
        });
    }
    /**
     * Get Value Chain Access
     * Get value chain access permissions for the current user.
     *
     * Args:
     * page: Page number
     * per_page: Items per page
     * is_active: Filter by active status
     * permission_level: Filter by permission level
     * search: Search term
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * ValueChainListResponse: Paginated value chain access list
     * @param page Page number
     * @param perPage Items per page
     * @param isActive Filter by active status
     * @param permissionLevel Filter by permission level
     * @param search Search term
     * @returns ValueChainListResponse Successful Response
     * @throws ApiError
     */
    public getValueChainAccessApiV1AuthValueChainsGet(
        page: number = 1,
        perPage: number = 10,
        isActive?: (boolean | null),
        permissionLevel?: (string | null),
        search?: (string | null),
    ): CancelablePromise<ValueChainListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/value-chains',
            query: {
                'page': page,
                'per_page': perPage,
                'is_active': isActive,
                'permission_level': permissionLevel,
                'search': search,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Value Chain Access
     * Get value chain access permissions for the current user.
     *
     * Args:
     * page: Page number
     * per_page: Items per page
     * is_active: Filter by active status
     * permission_level: Filter by permission level
     * search: Search term
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * ValueChainListResponse: Paginated value chain access list
     * @param page Page number
     * @param perPage Items per page
     * @param isActive Filter by active status
     * @param permissionLevel Filter by permission level
     * @param search Search term
     * @returns ValueChainListResponse Successful Response
     * @throws ApiError
     */
    public getValueChainAccessApiV1AuthValueChainsGet1(
        page: number = 1,
        perPage: number = 10,
        isActive?: (boolean | null),
        permissionLevel?: (string | null),
        search?: (string | null),
    ): CancelablePromise<ValueChainListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/value-chains',
            query: {
                'page': page,
                'per_page': perPage,
                'is_active': isActive,
                'permission_level': permissionLevel,
                'search': search,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Country Access
     * Get country access permissions for the current user.
     *
     * Args:
     * page: Page number
     * per_page: Items per page
     * is_active: Filter by active status
     * permission_level: Filter by permission level
     * search: Search term
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * CountryListResponse: Paginated country access list
     * @param page Page number
     * @param perPage Items per page
     * @param isActive Filter by active status
     * @param permissionLevel Filter by permission level
     * @param search Search term
     * @returns CountryListResponse Successful Response
     * @throws ApiError
     */
    public getCountryAccessApiV1AuthCountriesGet(
        page: number = 1,
        perPage: number = 10,
        isActive?: (boolean | null),
        permissionLevel?: (string | null),
        search?: (string | null),
    ): CancelablePromise<CountryListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/countries',
            query: {
                'page': page,
                'per_page': perPage,
                'is_active': isActive,
                'permission_level': permissionLevel,
                'search': search,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Country Access
     * Get country access permissions for the current user.
     *
     * Args:
     * page: Page number
     * per_page: Items per page
     * is_active: Filter by active status
     * permission_level: Filter by permission level
     * search: Search term
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * CountryListResponse: Paginated country access list
     * @param page Page number
     * @param perPage Items per page
     * @param isActive Filter by active status
     * @param permissionLevel Filter by permission level
     * @param search Search term
     * @returns CountryListResponse Successful Response
     * @throws ApiError
     */
    public getCountryAccessApiV1AuthCountriesGet1(
        page: number = 1,
        perPage: number = 10,
        isActive?: (boolean | null),
        permissionLevel?: (string | null),
        search?: (string | null),
    ): CancelablePromise<CountryListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/countries',
            query: {
                'page': page,
                'per_page': perPage,
                'is_active': isActive,
                'permission_level': permissionLevel,
                'search': search,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Data Permissions
     * Get data permissions for the current user.
     *
     * Args:
     * page: Page number
     * per_page: Items per page
     * is_active: Filter by active status
     * permission_level: Filter by permission level
     * data_type: Filter by data type
     * search: Search term
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * DataPermissionListResponse: Paginated data permissions list
     * @param page Page number
     * @param perPage Items per page
     * @param isActive Filter by active status
     * @param permissionLevel Filter by permission level
     * @param dataType Filter by data type
     * @param search Search term
     * @returns DataPermissionListResponse Successful Response
     * @throws ApiError
     */
    public getDataPermissionsApiV1AuthDataPermissionsGet(
        page: number = 1,
        perPage: number = 10,
        isActive?: (boolean | null),
        permissionLevel?: (string | null),
        dataType?: (string | null),
        search?: (string | null),
    ): CancelablePromise<DataPermissionListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/data-permissions',
            query: {
                'page': page,
                'per_page': perPage,
                'is_active': isActive,
                'permission_level': permissionLevel,
                'data_type': dataType,
                'search': search,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Data Permissions
     * Get data permissions for the current user.
     *
     * Args:
     * page: Page number
     * per_page: Items per page
     * is_active: Filter by active status
     * permission_level: Filter by permission level
     * data_type: Filter by data type
     * search: Search term
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * DataPermissionListResponse: Paginated data permissions list
     * @param page Page number
     * @param perPage Items per page
     * @param isActive Filter by active status
     * @param permissionLevel Filter by permission level
     * @param dataType Filter by data type
     * @param search Search term
     * @returns DataPermissionListResponse Successful Response
     * @throws ApiError
     */
    public getDataPermissionsApiV1AuthDataPermissionsGet1(
        page: number = 1,
        perPage: number = 10,
        isActive?: (boolean | null),
        permissionLevel?: (string | null),
        dataType?: (string | null),
        search?: (string | null),
    ): CancelablePromise<DataPermissionListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/data-permissions',
            query: {
                'page': page,
                'per_page': perPage,
                'is_active': isActive,
                'permission_level': permissionLevel,
                'data_type': dataType,
                'search': search,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Grant Value Chain Access
     * Grant value chain access (admin only).
     *
     * Args:
     * request: Value chain access grant request
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Grant confirmation
     * @param requestBody
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public grantValueChainAccessApiV1AuthValueChainsGrantPost(
        requestBody: GrantValueChainAccessRequest,
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/value-chains/grant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Grant Value Chain Access
     * Grant value chain access (admin only).
     *
     * Args:
     * request: Value chain access grant request
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Grant confirmation
     * @param requestBody
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public grantValueChainAccessApiV1AuthValueChainsGrantPost1(
        requestBody: GrantValueChainAccessRequest,
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/value-chains/grant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Grant Country Access
     * Grant country access (admin only).
     *
     * Args:
     * request: Country access grant request
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Grant confirmation
     * @param requestBody
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public grantCountryAccessApiV1AuthCountriesGrantPost(
        requestBody: GrantCountryAccessRequest,
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/countries/grant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Grant Country Access
     * Grant country access (admin only).
     *
     * Args:
     * request: Country access grant request
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Grant confirmation
     * @param requestBody
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public grantCountryAccessApiV1AuthCountriesGrantPost1(
        requestBody: GrantCountryAccessRequest,
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/countries/grant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Grant Data Permission
     * Grant data permission (admin only).
     *
     * Args:
     * request: Data permission grant request
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Grant confirmation
     * @param requestBody
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public grantDataPermissionApiV1AuthDataPermissionsGrantPost(
        requestBody: GrantDataPermissionRequest,
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/data-permissions/grant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Grant Data Permission
     * Grant data permission (admin only).
     *
     * Args:
     * request: Data permission grant request
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * PermissionGrantResponse: Grant confirmation
     * @param requestBody
     * @returns PermissionGrantResponse Successful Response
     * @throws ApiError
     */
    public grantDataPermissionApiV1AuthDataPermissionsGrantPost1(
        requestBody: GrantDataPermissionRequest,
    ): CancelablePromise<PermissionGrantResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/data-permissions/grant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Financial Data Access
     * Get all financial data access permissions for the current user.
     *
     * Returns list of country-source combinations the user has access to.
     *
     * Args:
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * List of financial data permissions
     * @returns any Successful Response
     * @throws ApiError
     */
    public getFinancialDataAccessApiV1AuthFinancialDataAccessGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/financial-data-access',
        });
    }
    /**
     * Get Financial Data Access
     * Get all financial data access permissions for the current user.
     *
     * Returns list of country-source combinations the user has access to.
     *
     * Args:
     * current_user: Current authenticated user
     * db: Database session
     *
     * Returns:
     * List of financial data permissions
     * @returns any Successful Response
     * @throws ApiError
     */
    public getFinancialDataAccessApiV1AuthFinancialDataAccessGet1(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/financial-data-access',
        });
    }
}
